import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { getRequisitionList, getRequisitionUUID, getWarehouseKeyValueList } from "../../../services";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import AddIcon from "@mui/icons-material/Add";
import toast, { Toaster } from "react-hot-toast";
import { addPrintLogHistory, getRequisitionLogHistory } from "../../../services/Production/RequisitionServices";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { getFormattedNumber, searchForMatch } from "../../utils/textUtils";
import { useReactToPrint } from "react-to-print";
import { LocalPrintshopOutlined } from "@mui/icons-material";
import Select from 'react-select';
import { confirmAlert } from "react-confirm-alert";

const RequisitionView = () => {
  const componentRef = useRef();
  let { id } = useParams();
  const [requisitionDetails, setRequisitionDetails] = useState(null);
  const [list, setList] = useState(null);
  const [rows, setRows] = useState(null);
  const [logData, setLogData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [requisitionListDetails, setRequisitionListDetails] = useState(null);
  const [index, setIndex] = useState(0);
  const [filterText, setFilterText] = useState("");
  const [wareOptions, setWareOptions] = useState([]);
  const [ware, setWare] = useState("");
  const [selectedWarehouse, setSelectedWarehouse] = useState("");
  const [selectedRecordId, setSelectedRecordId] = useState("");
  const location = useLocation()









  useEffect(() => {
    getWarehouseKeyValueList().then((res) => {
      if (res.errorCode === 0) {
        const options = res.responsePacket.map((d) => ({
          value: d.key,
          label: d.value,
        }));
        if (location.state?.ware) {
          setSelectedWarehouse(location.state.ware)
        }
        else {
          setSelectedWarehouse(options[0]);
        }
        setWareOptions(options);
      }
    });
  }, []);







  const getAllRequisitionRecords = (e) => {
    let requisition_data = {
      page: index,
      size: 15,
      search: filterText,
      uuid2: e || selectedWarehouse?.value
    };
    getRequisitionList(requisition_data).then((res) => {
      if (res.errorCode === 0) {
        if (index === 0) {
          const data = res.responsePacket.data;
          setList(data);
          setRows(data);
        } else {
          const setRequisitionClone = [...rows, ...res.responsePacket.data];
          setList(setRequisitionClone);
          setRows(setRequisitionClone);
        }
        setIndex(index + 1);
        setRequisitionListDetails({
          recordsFiltered: res.responsePacket.recordsFiltered,
          recordsTotal: res.responsePacket.recordsTotal,
          total: res.responsePacket.total,
        });
      } else {
        toast(res.message);
      }
    });
  };

  useEffect(() => {
    if (selectedWarehouse) {
      getAllRequisitionRecords();
    }

    getRequisitionDetails(id);
  }, [id]);

  useEffect(() => {
    if (selectedWarehouse) {
      getAllRequisitionRecords();
    }
  }, [filterText, selectedWarehouse]);

  useEffect(() => {
    if (tabIndex === 1) {
      getRequisitionLogHistory(requisitionDetails.requisitionCode).then(
        (res) => {
          if (res.errorCode === 0) {
            const d = res.responsePacket;
            setLogData(d);
          } else {
            toast(res.message);
          }
        }
      );
    }
    if (tabIndex === 0) {
      getRequisitionDetails(id);
    }
  }, [tabIndex]);

  const getRequisitionDetails = (id) => {
    getRequisitionUUID(id).then((res) => {
      if (res.errorCode === 0) {
        let d1 = res.responsePacket.requestDate;
        let dd = new Date(d1)
          .toISOString()
          .replace(/T.*/, "")
          .split("-")
          .reverse()
          .join("-");
        res.responsePacket.requestDate = dd;

        setRequisitionDetails(res.responsePacket);
        setLoading(true);
      } else {
        toast.error(res.message);
      }
    });
  };

  const handleSelectRequisition = (row) => {
    if (requisitionDetails && requisitionDetails.recordId === row.recordId) {
      return;
    }
    getRequisitionDetails(row.recordId);
    setTabIndex(0);
    setRequisitionDetails(null);
    setLogData(null);
  };

  let time;
  const handleSearch = (e) => {
    const { value } = e.target;
    clearTimeout(time);
    time = setTimeout(() => {
      setIndex(0);
      setFilterText(value);
    }, 500);
  };


  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    // onAfterPrint: () => {
    //   addPrintLogHistory(id).then((e) => {
    //     if (e.errorCode === 0) {
    //     }
    //   })
    // }
  });




  const handleSelectWarehouse = (e) => {
    setSelectedWarehouse(e);
    getAllRequisitionRecords(e.value);
    setIndex(0);
    setFilterText("");
  };


  return (
    <>
      <div
        className="list-column column d-print-none"
        style={{ width: "300px" }}
      >
        <div className="fill list-header topgrad d-print-none">
          <div className="listFilterAndSearch list-filter pt-3 d-flex align-items-center">
            <Link to="/requisition/new" className="newListBtn">
              <AddIcon />
              New
            </Link>
            <div className="listFilter">
              <Select value={selectedWarehouse} options={wareOptions} onChange={handleSelectWarehouse} />
            </div>
            <div className="input-group paginationSearchInput listSearch">
              <div className="input-group-prepend ">
                <span className="input-group-text" id="basic-addon1">
                  <SearchRoundedIcon />
                </span>
              </div>
              <input autoComplete="off" className="form-control" type="text" placeholder="Search..." onChange={handleSearch} />
            </div>
          </div>
        </div>
        <div className="scroll-y fill body scrollbox list-body">
          <div className="table-responsive overflow-initial">
            <table
              id="ember7912"
              className="table zi-table table-hover ember-view header-fixed"
            >
              {list &&
                (list.length > 0 ? (
                  <tbody>
                    {list &&
                      list.map((row, index) => (
                        <tr
                          key={index}
                          className={`listTr ${id === row.recordId ? "activeRecord" : ""
                            }`}
                          onClick={() => handleSelectRequisition(row)}
                        >
                          <td>
                            <Link
                              to={`/requisition/${row.recordId}`}
                              className={`${id === row.recordId
                                ? "text-primary"
                                : "text-grey"
                                }`}
                            >
                              <span className="titleTr">
                                {row.requisitionCode}
                              </span>
                              <span className="d-flex justify-content-between">
                                <span className="text-primary">
                                  {row?.requestingDepartmentTitle}
                                </span>
                                <span>By: {row?.requestingUserTitle}</span>
                              </span>
                            </Link>
                          </td>
                        </tr>
                      ))}
                    {requisitionListDetails &&
                      requisitionListDetails.recordsTotal > list.length && (
                        <div className="pt-3">
                          <button
                            className="btn mx-auto newListBtn"
                            onClick={getAllRequisitionRecords}
                          >
                            Load More
                          </button>
                        </div>
                      )}
                  </tbody>
                ) : (
                  <div className="my-3 text-white text-center">
                    No Data Available!
                  </div>
                ))}
            </table>
          </div>
        </div>
      </div >

      <div className="column content-column " style={{ left: "301px" }}>
        <div className="header no-border d-flex align-items-center p-4">
          <h3 className="over-flow header-title text-right font-size-18 mr-4 mb-0">
            {requisitionDetails?.requisitionCode}
            &nbsp;
          </h3>
        </div>
        <Tabs
          selectedIndex={tabIndex}
          onSelect={(index) => setTabIndex(index)}
          className="upperTabs"
        >
          <TabList>
            <Tab>Primary Details</Tab>
            <Tab>Log History</Tab>
          </TabList>
          <TabPanel className="p-3">
            <div ref={componentRef} className="ember-view scroll-y noscroll-x fill body scrollbox">
              <br />

              <div className="customTable" id="scroll">

                <button className="tooltip-container ember-view btn btn-primary print-btn position-absolute" onClick={() => {
                  confirmAlert({
                    title: (
                      <span className="d-flex align-items-center justify-content-center" style={{ fontSize: "16px", fontWeight: "700" }}>
                        Print Requisition
                      </span>
                    ),
                    // message: <p className="text-center">Are you sure you want to logout?</p>,
                    buttons: [
                      {
                        label: "Yes",
                        onClick: () => {
                          handlePrint();
                        },
                        className: "logoutBtn",
                      },
                      {
                        label: "Cancel",
                        className: "logoutBtn",
                      },
                    ],
                  })
                }} style={{ top: "10px", right: "0px" }}>
                  <LocalPrintshopOutlined />
                </button>
                <table>
                  <tbody>
                    <tr>
                      <td className="font-large text-uppercase font-xs text-open">
                        {requisitionDetails?.requisitionCode}
                      </td>
                    </tr>

                    <tr>
                      <td>Requesting User:</td>
                      <td>{requisitionDetails?.requestingUserTitle}</td>
                    </tr>
                    <tr>
                      <td>Requested Date:</td>
                      <td>{requisitionDetails?.requestDate}</td>
                    </tr>
                    <tr>
                      <td>Department:</td>
                      <td>{requisitionDetails?.requestingDepartmentTitle}</td>
                    </tr>
                    <tr>
                      <td>Warehouse:</td>
                      <td>{requisitionDetails?.warehouseTitle}</td>
                    </tr>
                    {/* <tr>
                                            <td>Note:</td>
                                            <td>{requisitionDetails?.note}</td>
                                        </tr> */}
                    <tr>
                      <td>Accepted:</td>
                      <td>
                        {requisitionDetails?.isAccepted ? "true" : "false"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <hr />

              <div className="customTable" id="scroll">
                {!loading
                  ? "loading"
                  : requisitionDetails?.requestedItemsBeanList.length !== 0 && (
                    <div>
                      REQUESTED ITEMS
                      <hr />
                      <table>
                        <thead>
                          <tr>
                            <td>S No.</td>
                            <td>Item</td>
                            <td>Quantity</td>
                            <td>Item Price</td>
                            <td>Total Price</td>
                          </tr>
                        </thead>
                        <tbody>
                          {requisitionDetails?.requestedItemsBeanList.map(
                            (item, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{item.itemTitle}</td>
                                <td>
                                  {getFormattedNumber(item.quantity)}&nbsp;
                                  {item.unitTitle}
                                </td>
                                <td>{Number(item.itemPrice).toFixed(2)}</td>
                                <td>{Number(item.total).toFixed(2)}</td>
                              </tr>
                            )
                          )}
                          <tr>
                            <td colSpan={4}><b>Grand Total</b></td>
                            <td >{<b>{Number(requisitionDetails?.requestedItemsBeanList.reduce((acc, item) => acc += (item.total || 0), 0)).toFixed(2)}</b>}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}

                <div id="ember3382" className="ember-view"></div>
              </div>
            </div>
          </TabPanel>
          <TabPanel className="p-3">
            <div className="ember-view scroll-y noscroll-x fill body scrollbox">
              <table className="customTable">
                {logData && logData.length === 0 ? (
                  "No Changes Found"
                ) : (
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Changes</th>
                    </tr>
                  </thead>
                )}
                {logData && (
                  <tbody>
                    {logData.length >= 1 &&
                      logData?.map((history, i) => (
                        <tr key={i}>
                          <td style={{ verticalAlign: "top", width: "80px" }}>
                            {history?.transactionDate?.substring(0, 10)}
                            :&nbsp;&nbsp;
                            <br />
                            Time:
                            {history?.transactionDate
                              ?.split("T")[1]
                              ?.substring(0, 5)}
                          </td>

                          <td>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: history?.message
                                  .replaceAll("\n", "<br />")
                                  .replaceAll("\t", "&nbsp;&nbsp;&nbsp;&nbsp;"),
                              }}
                            />
                            {/* {history?.message.split("\n").map((b, j) => (
                                                        <div key={j}>
                                                            {b.includes("\t") ? <div style={{ marginLeft: "20px" }}>{b}</div> : b.includes("\t\t") ? <div style={{ marginLeft: "40px" }}>{b}</div> : b}
                                                        </div>
                                                    ))} */}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                )}
              </table>
            </div>
          </TabPanel>
        </Tabs>
      </div>
      <Toaster />
    </>
  );
};

export default RequisitionView;
